/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* ~~~~~~~~~~ Partner Form Page Template Webpack ~~~~~~~~~~ */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

    /* ~~~~~~~~~~ Global Assets ~~~~~~~~~~ */

        // import "bootstrap/scss/_alert.scss";
        // import "bootstrap/scss/_badge.scss";
        // import "bootstrap/scss/_breadcrumb.scss";
        // import "bootstrap/scss/_button-group.scss";
        // import "bootstrap/scss/_card.scss";
        // import "bootstrap/scss/_carousel.scss";
        // import "bootstrap/scss/_close.scss";
        // import "bootstrap/scss/_code.scss";
        // import "bootstrap/scss/_custom-forms.scss";
        // import "bootstrap/scss/_forms.scss";
        // import "bootstrap/scss/_input-group.scss";
        // import "bootstrap/scss/_jumbotron.scss";
        // import "bootstrap/scss/_list-group.scss";
        // import "bootstrap/scss/_media.scss";
        // import "bootstrap/scss/_modal.scss";
        // import "bootstrap/scss/_nav.scss";
        // import "bootstrap/scss/_pagination.scss";
        // import "bootstrap/scss/_popover.scss";
        // import "bootstrap/scss/_progress.scss";
        // import "bootstrap/scss/_spinners.scss";
        // import "bootstrap/scss/_toast.scss";
        // import "bootstrap/scss/_tooltip.scss";

        // import "bootstrap/js/dist/alert";
        // import "bootstrap/js/dist/button";
        // import "bootstrap/js/dist/carousel";
        // import "bootstrap/js/dist/collapse";
        // import "bootstrap/js/dist/modal";
        // import "bootstrap/js/dist/popover";
        // import "bootstrap/js/dist/scrollspy";
        // import "bootstrap/js/dist/tab";
        // import "bootstrap/js/dist/toast";
        // import "bootstrap/js/dist/tooltip";

        import "../../../styles/style.scss";

        import "../../../scripts/index";


    /* ~~~~~~~~~~ Template Parts ~~~~~~~~~~ */

        import "../../template-parts/header/index";
        import "../../template-parts/footer/index";
        import "../../template-parts/main-tag/index";
        import "../../template-parts/mobile-navigation/index";
        import "../../template-parts/return-to-top/index";
        import "../../template-parts/crunch-button/index";
        import "../../template-parts/social-icons/index";
        import "../../template-parts/gravity-forms/index";


    /* ~~~~~~~~~~ Custom Assets ~~~~~~~~~~ */

        import "./_partner-form-styles.scss";
